import { render, staticRenderFns } from "./chat.vue?vue&type=template&id=538c5cda&scoped=true&"
import script from "./chat.vue?vue&type=script&lang=js&"
export * from "./chat.vue?vue&type=script&lang=js&"
import style0 from "./chat.css?vue&type=style&index=0&id=538c5cda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538c5cda",
  null
  
)

export default component.exports